import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Button } from "../ui/button";

// Booklet placement (many-to-many, ordered). Placement never changes who must acknowledge.
export function WsBooklets({ rid, booklets, onSaved }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { setRows(booklets.map((b) => ({ ...b, on: b.included, pos: b.position || b.count + 1 }))); }, [booklets]);
  const upd = (id, patch) => setRows((rs) => rs.map((r) => (r.id === id ? { ...r, ...patch } : r)));
  const dirty = rows.some((r) => r.on !== r.included || (r.on && r.included && Number(r.pos) !== r.position));
  const save = async () => {
    if (busy) return; setBusy(true);
    try {
      await api.put(`/policies/${rid}/booklets`, { placements: rows.filter((r) => r.on).map((r) => ({ collection_id: r.id, position: Number(r.pos) || null })) });
      toast.success("Booklet placement saved"); onSaved();
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-col gap-2" data-testid="ws-booklets">
      {rows.length === 0 && <p className="text-sm text-slate-400">No booklets exist yet — create one under Books.</p>}
      {rows.map((r) => {
        const max = r.included ? r.count : r.count + 1;
        return (
          <div key={r.id} className={`flex items-center gap-2 rounded-lg border px-2.5 py-1.5 ${r.on ? "border-emerald-300 bg-emerald-50/50" : "border-slate-200"}`}>
            <input type="checkbox" data-testid={`ws-booklet-${r.id}`} checked={r.on} onChange={(e) => upd(r.id, { on: e.target.checked })} />
            <span className="text-sm text-slate-800 flex-1 truncate">{r.name}</span>
            {r.on && (
              <label className="text-[11px] text-slate-500 flex items-center gap-1">Position
                <input type="number" min={1} max={max} data-testid={`ws-booklet-pos-${r.id}`} value={r.pos} onChange={(e) => upd(r.id, { pos: e.target.value })}
                  className="w-14 h-7 rounded border border-slate-200 px-1 text-sm" /> of {max}
              </label>
            )}
          </div>
        );
      })}
      <p className="text-[11px] text-slate-400">Where the document appears to readers. Who must acknowledge it is set under Audience.</p>
      {dirty && <Button data-testid="ws-save-booklets" disabled={busy} onClick={save} variant="outline" className="self-start">Save placement</Button>}
    </div>
  );
}
